export const MCBkeyToParamMap = {
  Details: "BD",
  AccountDetails: "AD",
  Beneficiaries: "BE",
  Transactions: "TR",
  Documents: "DO",
  LienAccountDetails: "LA",
  UnlienAccountDetails: "UL",
  LienTransactions: "LT",
  Transfers: "TF",
};
